import React, { useEffect, useState } from 'react';
import {
    Card, Form, Row, Col, Button,
} from 'react-bootstrap';

// import api from '../../api';

import _ from 'lodash';
import MaterialTable, { MTableBody } from 'material-table';
import {
    TableCell, TableFooter, TableHead, Paper,
} from '@material-ui/core';
import TableRow from '@material-ui/core/TableRow';
import { History } from '@material-ui/icons';
import Required from '../Required';
import { floatRenderer } from '../../services/formatSvc';
import { localization, modifyDefaultOptions, tableIconsModified } from '../../helpers/table';
import { renderEditMoneyComponent } from '../../pages/index/Shared';
import { MonetaryFloatInput } from '../common/MonetaryFloatInput';
import useAPI from '../../hooks/useAPI';
import useToast from '../../hooks/useToast';

function range(start, end) {
    return start && end ? Array((end < start ? start : end) - start + 1).fill().map((_, idx) => start + idx) : [];
}

function flattenSums(buyKvrs, yearRange) {
    return (buyKvrs || []).map((k) => {
        const row = {
            id: k.id,
            costKvrId: k.costKvrId,
            costKvr: k.costKvr,
        };
        yearRange.forEach((y) => {
            row[y] = k.sums && k.sums.length > 0
                ? (k.sums.find((s) => s.year === y) || {}).draftSum
                : null;
        });
        return row;
    }).flat();
}

export default function BuyKvrs({
                                    buy, showAll, onChange, readOnly,
                                }) {
    const api = useAPI();
    const addToast = useToast();

    const [expenseTypes, setExpenseTypes] = useState([]);

    useEffect(async () => {
        let et = await api.get(`/mng/expenseTypes`);
        setExpenseTypes(et);
    }, []);


    // #region Modify items
    const handleExpenseTypeChange = (etId) => {
        onChange(parseInt(etId), 'expenseTypeId');
        updateKvrs(parseInt(etId));
    };

    const updateKvrs = (etId) => {
        const newKvrs = expenseTypes.find((et) => et.id === parseInt(etId))
            .costKvrs
            .map((k) => ({
                buyId: buy.id, costKvrId: k.id, costKvr: k, sums: [],
            }));
        const buyKvrsCopy = ((buy.buyKvrs || []).concat(newKvrs)).reduce((arr, i) => {
            if (newKvrs.find((nk) => nk.costKvrId === i.costKvrId)) arr.push(i);
            return arr;
        }, []);
        onChange(buyKvrsCopy, 'buyKvrs');
    };

    const validateSumChange = async (costKvrId, year, sum) => {
        if (buy.id) {
            const res = await api.post(`/buys/${buy.id}/kvrs/0/sums/0/remainder`, {
                buyId: buy.id,
                costKvrId,
                year,
                sum,
            });
            if (res.remainder < -0.005) {
                addToast.error('Введенная оценочная стоимость меньше суммы акцепта. Обратитесь в ПФУ для коррекции суммы акцепта или увеличьте оценочную стоимость');
                return false;
            }
        }
        return true;
    };

    const handleSumsChange = async (row) => {
        const buyKvrsCopy = [...buy.buyKvrs];
        const buyKvrCopy = buyKvrsCopy.find((k) => k.costKvrId === row.costKvrId);
        for (const y of range(buy.year || new Date().getFullYear(), new Date().getFullYear())) {
            const oldSum = buyKvrCopy.sums.find((s) => s.year === y);
            if (oldSum) {
                if (await validateSumChange(row.costKvrId, y, row[y.toString()])) {
                    oldSum.draftSum = row[y.toString()];
                }
            } else buyKvrCopy.sums.push({ year: y, draftSum: row[y.toString()] });
        }
        onChange(buyKvrsCopy, 'buyKvrs');
    };
    // #endregion

    const columns = [
        { title: "Код статьи", field: "costKvr.num", cellStyle: { textAlign: 'center'}, editable: 'never' },
        { title: "Наименование", field: "costKvr.name", editable: 'never' }
    ].concat(range(buy.year || new Date().getFullYear(), new Date().getFullYear())
        .map(y => ({
            title: y.toString(),
            field: y.toString(),
            render: (rowData) => <div align="center">{floatRenderer(rowData[y])}</div>,
            //editable: !readOnly,//todo
            editComponent: (props) => {
                // (props.value)
                // let value = props.value && props.value.find(v => v.year === buy.year);
                return <MonetaryFloatInput value={props.value || 0} onChange={props.onChange} table/>
            },
        }))
    ).concat([
        { title: "Код направления расходов гранта", field: "costKvr",
            cellStyle: { textAlign: 'center'},
            editable: 'never',
            render: (rowData) => rowData.costKvr.costAgrs
                .filter(ca => !buy.agreementId || !ca.agreements?.length || ca.agreements.find(a => a.id === buy.agreementId))   //отбираем такие статьи (соглашение), у которых соглашение либо не указано, либо совпадает с выбранным в закупке
                .map(ca => ca.num)
                .join(', ')
        }
    ]);

    return (
        <Card className="mb-4">
            <Card.Header as={Card.Title} className="p-4">Оценочная стоимость закупки</Card.Header>

            <Card.Body className="p-4">
                <Row className="mb-4">
                    <Form.Group as={Col}>
                        <Form.Label>
                            Вид расходов
                            <Required />
                        </Form.Label>
                        <Form.Control
                            required
                            as="select"
                            value={buy.expenseTypeId || ''}
                            disabled={readOnly || (buy.status === 'approved' || buy.status === 'declined')}
                            onChange={(e) => handleExpenseTypeChange(e.target.value)}
                        >
                            <option value="" />
                            {expenseTypes && expenseTypes.map((et) => <option key={et.id} value={et.id}>{et.name}</option>)}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">Выберите вид расходов</Form.Control.Feedback>
                    </Form.Group>
                </Row>
                <MaterialTable
                    options={modifyDefaultOptions({
                        actionsColumnIndex: 0,
                        filtering: false,
                        search: false,
                        paging: false,
                        toolbar: false,
                    })}
                    icons={tableIconsModified}
                    localization={localization}
                    columns={columns}
                    data={flattenSums(buy.buyKvrs.filter((k) => showAll || !k.costKvr.hideInBuy), range(buy.year || new Date().getFullYear(), new Date().getFullYear()))}
                    editable={{
                        isEditable: (rowData) => !readOnly,
                        onRowUpdate: (newData, oldData) =>
                            new Promise(async (resolve, reject) => {
                                await handleSumsChange(newData);
                                resolve();
                            }),
                    }}
                    // actions={[
                    //     {
                    //         custom: true,
                    //         hidden: false,
                    //         icon: () =><History style={{color: '#0D6EFD'}}/>,
                    //         tooltip: 'История изменений',
                    //         onClick: (data) => {
                    //             setHistoryModalReport({ id: data.id, num: data.num, name: data.name })
                    //         }
                    //     },
                    // ]}
                    components={{
                        Header: (props) => (
                            <TableHead>
                                <TableRow>
                                    <TableCell align="center" style={tableHeaderStyling}>Действ.</TableCell>
                                    <TableCell colSpan={2} align="center" style={tableHeaderStyling}>Код вида расхода (КВР)</TableCell>
                                    <TableCell colSpan={range(buy.year || new Date().getFullYear(), new Date().getFullYear()).length || 1} align="center" style={tableHeaderStyling}>Сумма (руб.)</TableCell>
                                    <TableCell align="center" style={tableHeaderStyling}>Код направления расходов гранта</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell style={tableHeaderStyling}> </TableCell>
                                    <TableCell align="center" style={tableHeaderStyling}>Код статьи</TableCell>
                                    <TableCell align="center" style={tableHeaderStyling}>Наименование</TableCell>
                                    {range(buy.year, new Date().getFullYear()).map((y) => <TableCell key={y} align="center" style={tableHeaderStyling}>{y}</TableCell>)}
                                    <TableCell style={tableHeaderStyling}> </TableCell>
                                </TableRow>
                            </TableHead>
                        ),
                        Body: (props) => (
                            <>
                                <MTableBody {...props} />
                                <TableFooter>
                                    <TableRow>
                                        <TableCell />
                                        <TableCell colSpan={2}> Итого:</TableCell>
                                        {range(buy.year || new Date().getFullYear(), new Date().getFullYear())
                                            .map((y) => (
                                                <TableCell key={y} align="center">
                                                    {floatRenderer((buy.buyKvrs || []).map((k) => k.sums.filter((s) => s.year === y)
                                                        .map((s) => s.draftSum)).flat()
                                                        .reduce((prev, item) => prev + item, 0))}
                                                </TableCell>
                                            ))}
                                        <TableCell />
                                    </TableRow>
                                </TableFooter>
                            </>
                        ),
                    }}
                />
            </Card.Body>
        </Card>
    );
}

const cardHeaderStyling = {
    display: 'flex', justifyContent: 'end', minHeight: 38,
};
const tableHeaderStyling = {
    fontSize: 12, background: 'white', color: '#000000de',
};
